import React from "react";
import "./emptyState.css";

const EmptyState = () => <div className="empty-state">No results yet.</div>;

export default EmptyState;